import React from "react";

import Header from "../../components/shared/Layouts/header/header";
import Sidebar from "../../components/shared/Layouts/sidebar/sidebar";
import SharedUtils from "../../components/shared/Common/utils";

import "./fullview.scss";

const containerStyle = {
    display: "grid",
    gridTemplateColumns: "200px auto", // Adjust "200px" for the desired sidebar width
    minHeight: "100vh",
    width: "100%",
    height: "100%",
    zoom: "80%"
};

const Style1 = {
    height: "100%",
    padding: 0,
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    flexGrow: 1,
};

class FullView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ra_support: true}
        }

    handleDOMContentLoaded = () => {
        document.getElementById("jsd-widget").style.scale = 0.8;
        document.getElementById("jsd-widget").style["color-scheme"] = "none";
     };

    getMeta = async () => {
        var r = await SharedUtils.apiPost("meta", {}).then((response) => {
            this.setState({ ra_support: response[0]['ra_support']}, () => {
                if(this.state.ra_support != false) {
                    const script = document.createElement('script');

                    script.src = "https://jsd-widget.atlassian.com/assets/embed.js";
                    script.id = 'jiraWidget';
                    script.setAttribute('async', true);
                    script.setAttribute('data-jsd-embedded', '');
                    script.setAttribute('data-key', "d0c7159f-131a-4bde-945b-b56f4868e189");
                    script.setAttribute('data-base-url', "https://jsd-widget.atlassian.com");

                    document.body.appendChild(script);

                    script.addEventListener('load', (event)=>{
                      window.document.dispatchEvent(new Event("DOMContentLoaded", {
                        bubbles: true,
                        cancelable: true
                        }));
                      }
                    )
                    window.addEventListener('DOMContentLoaded', this.handleDOMContentLoaded);
                    return () => {
                      document.body.removeChild(script);
                      window.removeEventListener('DOMContentLoaded', this.handleDOMContentLoaded);
                    }
               }
            });

        });
    }

    clickOutside(e) {
           document.getElementById("header").click();       
    }
    componentDidMount () {
        this.getMeta();
    }
  render() {
    return (
      <>
            <div className="App" style={Style1} onClick={this.clickOutside} >
                <div className="container-fluid" style={Style1}>
                    <div className="d-flex" style={containerStyle}>
              <Sidebar />
              <div className="col content">
                <Header />
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default FullView;
